import React from 'react';

/**
 * Keeps a page crash from turning into a blank screen: business users get a
 * plain-language message, the technical detail stays available, and the app
 * never silently loses their work.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Caply page error:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="card p-6 max-w-xl">
        <h2 className="text-sm font-semibold text-navy-900">This page ran into a problem</h2>
        <p className="mt-2 text-xs text-slate-600">
          Nothing was lost. Reload the page to continue — if it keeps happening, tell us what you were doing and we&rsquo;ll fix it.
        </p>
        <div className="mt-3 flex gap-2">
          <button onClick={() => window.location.reload()} className="btn-primary text-xs py-1.5 px-3">
            Reload page
          </button>
          <button
            onClick={() => { this.setState({ error: null }); }}
            className="btn-secondary text-xs py-1.5 px-3"
          >
            Try again
          </button>
        </div>
        <details className="mt-4">
          <summary className="text-xs text-slate-400 cursor-pointer">Technical details</summary>
          <pre className="mt-2 text-[11px] bg-slate-50 border border-slate-200 rounded-lg p-3 whitespace-pre-wrap text-slate-600 max-h-48 overflow-auto">
            {String(this.state.error?.stack || this.state.error)}
          </pre>
        </details>
      </div>
    );
  }
}
